import React from 'react';

import {
  Container,
  Content,
  Typography,
  DownloadIcon,
} from './styles';

const DownloadMobile = () => (
  <Container>
    <Typography>Download & install the screen recorder app on your mobile phone</Typography>

    <Content>
      <a href="itms-apps://itunes.apple.com/app/apple-store/id1491481687" aria-label="Download from the App Store">
        <DownloadIcon
          src="/images/app-store-bagde.svg"
          alt="App Store"
        />
      </a>

      <a href="https://play.google.com/store/apps/details?id=com.testermobileapp" aria-label="Download from Google Play">
        <DownloadIcon
          src="/images/google-play-badge.png"
          alt="Google Play"
        />
      </a>
    </Content>
  </Container>
);

export default DownloadMobile;
